import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { change } from 'redux-form';
import _ from 'lodash';

import { submitDelay } from 'Common/GeneralHelper';
import { APPLICATION_HOH_FORM_NAME } from 'Common/FormEnum';
import { addToQueryString } from 'Common/Helpers/querystring';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';

import HoHForm from '../components/hoh/HoHForm';
import { updateHOH } from '../state/hub/actions';
import { Filter, Main } from '../../../containers';
import { MODIFY_BUTTON_TEXT } from '../helpers/Constants';

class HoH extends Component {
  static path = '/manageapplication/:familyId/hoh/';

  getRootUrl = () => {
    const { isSecondReview, isVerification, history } = this.props;
    const currentQueryString = _.get(history, 'location.search', '');
    const queryString = addToQueryString(currentQueryString, {
      secondReview: 0,
      verification: 0,
    });

    if (isSecondReview) {
      const queryString = addToQueryString(currentQueryString, {
        secondReview: 1,
        verification: 0,
      });
      return `${this.props.match.url.replace('/hoh', '')}${queryString}`;
    }
    if (isVerification) {
      const queryString = addToQueryString(currentQueryString, {
        secondReview: 0,
        verification: 1,
      });
      return `${this.props.match.url.replace('/hoh', '')}${queryString}`;
    }

    return `${this.props.match.url.replace('/hoh', '')}${queryString}`;
  };

  componentDidMount() {
    //if no members kick back
    if (!this.props.members) {
      this.props.history.replace(this.getRootUrl());
    }
  }

  getHoH = () => {
    if (this.props.members && this.props.appInfo) {
      let hoh = this.props.members.find((x) => x.IsHOH);

      if (hoh !== null) {
        if (hoh === undefined && this.props.students.length > 0) {
          hoh = {
            FirstName: this.props.students[0].HHFirstName,
            LastName: this.props.students[0].HHLastName,
            LanguageId: this.props.students[0].LanguageId,
          };
        }
        return hoh;
      } else {
        return {};
      }
    }
  };

  saveHOH = (values) => {
    return submitDelay().then(() => {
      this.props.updateHOH(values);
      this.props.history.push(this.getRootUrl());
    });
  };

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      usePageWidth: true,
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        isReadOnly,
        formName: APPLICATION_HOH_FORM_NAME,
        saveButtonProps: {
          content: MODIFY_BUTTON_TEXT,
        },
        shown: true,
      },
    };
  };

  handleSSNChange = (e, value) => {
    if (value) {
      this.props.change(APPLICATION_HOH_FORM_NAME, Fields.NoSSN, false);
    }
  };

  handleNoSSNChange = (e, checked) => {
    if (checked) {
      this.props.change(APPLICATION_HOH_FORM_NAME, Fields.SSN, null);
    }
  };

  render() {
    return (
      <Fragment>
        <Filter title={'Head of Household'} />
        <Main {...this.getMainProps()}>
          <HoHForm
            initialValues={this.getHoH()}
            familyId={this.props.match.params.familyId}
            onSubmit={this.saveHOH}
            handleSSNChange={this.handleSSNChange}
            handleNoSSNChange={this.handleNoSSNChange}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    members: state.ManageApplicationState.hub.tempApplication.Members,
    students: state.ManageApplicationState.hub.tempApplication.Students,
    isSecondReview: state.ManageApplicationState.hub.isSecondReview,
    isVerification: state.ManageApplicationState.hub.isVerification,
    appInfo:
      state.ManageApplicationState.hub.tempApplication.ApplicationInformation,
  };
};

HoH = withRouter(connect(mapStateToProps, { updateHOH, change })(HoH));
export { HoH };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/subpages/HoH.js